import React, { useRef, useState, useEffect } from "react";
import { changeLanguage, setShowNoteApp } from "../../store/actions/actions";
import { connect } from "react-redux";

import LeftBar from "../Project/Dashboard/LeftBar";
import NavBar from "../Project/Dashboard/NavBar";
import ProjectRedux from "../Project/ProjectRedux";
import Chat from "../Project/Dashboard/Chat";
import * as ProjectStyle from "../Project/project.module.css";
import { StyleRoot } from "radium";
import WhiteBoard from "./Whiteboard/index";


function WhiteBoardPage({ setShowNoteApp }) {
  const pageRef = useRef(null);
  useEffect(() => {
    setShowNoteApp(true);
    pageRef && pageRef.current.scrollIntoView();
  }, []);



  return (
    <>
      <ProjectRedux />
      <div className="h-100" ref={pageRef}>
        <LeftBar mobile />
        <div className="container-fluid h-100" style={{ overflow: "hidden" }}>
          <NavBar />
          <div className="row" style={{ height: "93vh", overflow: "hidden" }}>
            <LeftBar />
            <div
              className="col-md-7 h-100 p-md-5 p-3 bg-graphite"
              style={{ overflow: "scroll" }}
            >
              <div className=" bg-graphite ">
                <div className="">
                  <div className="d-flex align-items-center rounded border border-dark">
                    <img
                      src={"data:image/png;base64,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"}
                      className={`bg-dark p-1 ${ProjectStyle.app_icon_image}`}
                    />
                    <h3 className="font-weight-bold text-white mx-2 mb-0">
                      {`White Board`}
                    </h3>
                  </div>
                  
                    <StyleRoot>
                      <WhiteBoard />
                    </StyleRoot>
                  
                  <div className="mt-3 mt-md-4">
                    <div className="mb-3 mb-md-5">
                     {/* <NoteApp /> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Chat module */}
            <div
              className="col-md-4 h-100 px-0 d-flex flex-column justify-content-between"
              style={{ overflow: "scroll" }}
            >
              <Chat />
            </div>
            {/* Chat module ends */}
          </div>
        </div>
      </div>
    </>
  );
}

export default connect(
  (state) => ({
    currentLanguage: state.currentLanguage,
    project: state.project,
  }),
  { changeLanguage, setShowNoteApp }
)(WhiteBoardPage);
